import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export const UnsavedChangesModal = ({
  onOpenChange,
  onDiscard,
  onGoBack,
}: {
  onOpenChange: (open: boolean) => void;
  onDiscard: () => void;
  onGoBack: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={true} onOpenChange={onOpenChange}>
      <DialogContent className="gap-10 sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t('ai_agents.unsaved_changes.title')}</DialogTitle>
          <DialogDescription>{t('ai_agents.unsaved_changes.body')}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:flex-row-reverse sm:justify-start">
          <Button onClick={onGoBack}>{t('common.go_back')}</Button>
          <Button variant="ghost" onClick={onDiscard}>
            {t('common.discard')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
